import React from 'react';
import { createPortal } from 'react-dom';
import { CallIcon } from './CallUI';
import './FloatingError.css';

export default function FloatingError({ message, onDismiss }) {
  if (!message) return null;
  return createPortal(<div className="floating-error-layer">
    <div className="floating-error-toast" role="alert" key={message}>
      <span className="floating-error-symbol" aria-hidden="true">!</span>
      <p>{message}</p>
      <button type="button" onClick={onDismiss} aria-label="סגירת ההתראה"><CallIcon name="close" /></button>
    </div>
  </div>, document.body);
}
